'use client';

import React from 'react';
import { useParallax } from 'react-scroll-parallax';
import PlayArrowRoundedIcon from '@mui/icons-material/PlayArrowRounded';
import { Theme, alpha } from '@mui/material';
import Avatar from '@mui/material/Avatar';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import { SxProps } from '@mui/system/styleFunctionSx';
import { BlockContainer } from '@/components/Blocks/BlockContainer';
import { VideoTeaserBlockModal } from '@/components/Blocks/VideoTeasrBlock/components/VideoTeaserBlockModal';
import { BlockTitle } from '@/components/Blocks/components/BlockTitle';
import { CmsHtmlContent } from '@/components/CmsHtmlContent';
import { useResolveBlockHeight } from '@/hooks/useResolveBlockHeight';
import { prefixCmsUrl } from '@/lib/prefixCmsUrl';
import { CmsVideoTeaserBlock } from '@/services/cms/blocks/CmsVideoTeaserBlock';

export interface VideoTeaserBlockProps extends CmsVideoTeaserBlock {
    sx?: SxProps<Theme>;
}

export const VideoTeaserBlock = ({ sx, ...props }: VideoTeaserBlockProps) => {
    const bgUrl = props.image?.link || props.video?.thumbnailUrl;
    const height = useResolveBlockHeight(props.height);
    const [open, setOpen] = React.useState(false);
    const handleOpen = async () => {
        setOpen(true);
    };
    const handleClose = () => setOpen(false);
    const { ref } = useParallax<HTMLDivElement>({
        translateY: ['-80px', '80px'],
    });

    return (
        <>
            <BlockContainer sx={sx} {...props}>
                <Box
                    onClick={handleOpen}
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        flexDirection: 'column',
                        height: height,
                        cursor: 'pointer',
                        ...(bgUrl
                            ? {
                                  backgroundImage: `url(${prefixCmsUrl(bgUrl)})`,
                                  backgroundSize: 'cover',
                                  backgroundPosition: '50% 50%',
                              }
                            : undefined),
                    }}
                >
                    <Box
                        ref={ref}
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            flexDirection: 'column',
                            cursor: 'pointer',
                        }}
                    >
                        <BlockTitle sx={{ color: 'white', textShadow: '0 0 0.5rem rgba(0,0,0,.85)' }} {...props} />
                        <Avatar sx={(theme) => ({ bgcolor: alpha(theme.palette.primary.main, 0.8), width: 100, height: 100, color: theme.palette.common.white })}>
                            <PlayArrowRoundedIcon sx={{ fontSize: 50 }} />
                        </Avatar>
                    </Box>
                </Box>
                {props.content ? (
                    <Container maxWidth="md">
                        <CmsHtmlContent html={props.content} />
                    </Container>
                ) : null}
            </BlockContainer>
            <VideoTeaserBlockModal video={props.video || undefined} open={open} onClose={handleClose} PaperProps={{ sx: { width: 800 } }} maxWidth="md" />
        </>
    );
};
